exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MdmMember_MdmMember_hy7cQ {\n    display: flex;\n    justify-content: left;\n    flex-flow: row wrap;\n    padding-left: 10px;\n}\n\n.MdmMember_FormTitle_1TbKu {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    padding-left: 10px;\n    display: flex;\n    flex-flow: row;\n    /*justify-content: right;*/\n}", ""]);

// Exports
exports.locals = {
	"MdmMember": "MdmMember_MdmMember_hy7cQ",
	"FormTitle": "MdmMember_FormTitle_1TbKu"
};